package com.eladfinish.bible.contest.screens.openQuestions.ui.dialogs

import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.material3.OutlinedTextField
import androidx.compose.material3.Text
import androidx.compose.material3.TextButton
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.input.ImeAction
import androidx.compose.ui.unit.dp
import com.eladfinish.bible.contest.screens.openQuestions.OpenQuestionsAction
import com.eladfinish.bible.contest.screens.openQuestions.OpenQuestionsState.DialogState.CustomSheetInput
import com.eladfinish.bible.contest.ui.components.dialogs.TextInputAlertDialog
import com.eladfinish.bible.contest.ui.layout.isKeyboardCoveringShortWindow

@Composable
internal fun CustomSheetInputDialog(
    state: CustomSheetInput,
    onAction: (OpenQuestionsAction) -> Unit,
    onDismiss: () -> Unit,
) {
    TextInputAlertDialog(
        title = "גיליון שאלות",
        onDismissRequest = { if (!state.isLoading) onDismiss() },
        buttons = {
            TextButton(
                onClick = onDismiss,
                enabled = !state.isLoading,
            ) { Text("ביטול") }
            if (state.isLoading) {
                CircularProgressIndicator(modifier = Modifier.padding(8.dp))
            } else {
                TextButton(onClick = { onAction(OpenQuestionsAction.SubmitCustomSheetUrl) }) {
                    Text("טען")
                }
            }
        },
    ) {
        if (!isKeyboardCoveringShortWindow()) {
            Text(
                text = "הזן כתובת של גיליון Google Sheets המכיל עמודת שאלות ועמודת תשובות.",
                modifier = Modifier.padding(bottom = 12.dp),
            )
        }
        OutlinedTextField(
            value = state.url,
            onValueChange = { onAction(OpenQuestionsAction.CustomSheetUrlChanged(it)) },
            label = { Text("כתובת הגיליון") },
            modifier = Modifier.fillMaxWidth(),
            singleLine = true,
            enabled = !state.isLoading,
        )
    }
}
